import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome,FaImages  } from 'react-icons/fa';
import LogoHeader from '../Assets/Image/Hiranand Agri solutions.png';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="logo text-center mb-4">
        <img src={LogoHeader} alt="Logo" style={{ height: '50px' }} />
      </div>
      <ul className="sidebar-nav list-unstyled px-1">
        <li>
          <NavLink to="/dashboard" end className="d-flex align-items-center gap-2">
            <FaHome /> Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/gallerydata" end className="d-flex align-items-center gap-2">
            <FaImages /> Gallery
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
